export default (component, prop) =>
  Object.prototype.hasOwnProperty.call(component.props, prop);
